"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var container = {};
function register(masks) {
    masks.forEach(function (_a) {
        var name = _a.name, funcs = tslib_1.__rest(_a, ["name"]);
        container[name] = funcs;
    });
}
exports.register = register;
function getMask(name) {
    return container[name];
}
exports.getMask = getMask;
//# sourceMappingURL=index.js.map